import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TfCheckboxComponent } from './tf-checkbox/tf-checkbox.component';

@NgModule({
    declarations: [
        TfCheckboxComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        TfCheckboxComponent
    ]
})
export class TfCheckboxModule {
}
